import { ChangeDetectorRef, Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AppSettings } from 'app/modules/shared/app.settings';
import { SearchLocationDirective } from 'app/modules/shared/directives/search-location.directive';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { EntityService } from 'app/modules/shared/services/entity.service';
import { MetaDataService } from 'app/modules/shared/services/meta-data.service';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BlockUIModule } from 'primeng/blockui';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { GoogleMapsService } from '../../../services/google-map.services';

@Component({
  selector: 'app-geo-search',
  templateUrl: './geo-search.component.html',
  styleUrl: './geo-search.component.scss',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, DropdownModule, TranslateModule, ButtonModule, DialogModule, BlockUIModule, InputTextModule, AutoCompleteModule, SearchLocationDirective],
})
export class GeoSearchComponent implements OnInit {
  @Input() field: any;
  @Input() form: any;
  formName: FormGroup;
  @Input() attributeLabels: [];
  @Input() moduleName: string;
  @Output() onAddressChange: EventEmitter<any> = new EventEmitter();
  defaultLbl: string;
  placeholder: any;
  map: google.maps.Map;
  infoWindow: google.maps.InfoWindow;
  visible: boolean = false;

  zoom = 4;
  position: any;
  cancelBtnText: any;
  saveBtnText: any;
  blockedDocument: boolean = false;
  newGeoLocation: any;
  newGeoAddress: any;
  premiseAddress;
  marker;
  showGoogleSearchBox: boolean = false;
  searchText: string = null;
  suggestions: any = [];
  selectedLocation;
  filteredLocations: any;
  markerlocation;
  placeId: any;
  errorMessage: string = '';
  centerCords: google.maps.LatLngLiteral = { lat: 18.5204, lng: 73.8567 };

  constructor(
    private formGroupDirective: FormGroupDirective,
    public cs: CommonBindingDataService,
    private cd: ChangeDetectorRef,
    private entityService: EntityService,
    private googleMapsService: GoogleMapsService,
    private metaDataService: MetaDataService
  ) {
    this.formName = formGroupDirective.control;

  }

  ngOnInit(): void {
    const latitude = this.metaDataService.latitude;
    const longitude = this.metaDataService.longitude;
    if (latitude !== null && longitude !== null) {
      this.centerCords = { lat: latitude, lng: longitude };
    }
    if (this.form) {
      this.formName = this.form;
    }
    if (this.moduleName === AppSettings.ENTITY_CODE.LOCATION) {
      this.selectedLocation = this.formName.controls[AppSettings.LOCATION_ATTRIBUTES.LOCATION_ADDRESS].value;
    }

    if (this.moduleName === AppSettings.ENTITY_CODE.EVENTS) {
      this.selectedLocation = this.formName.controls[AppSettings.EVENT_ATTRIBUTES.EVENT_ADDRESS].value;
    }
    if (this.moduleName === AppSettings.ENTITY_CODE.DRIVER) {
      this.selectedLocation = this.formName.controls[AppSettings.DRIVER_ATTRIBUTES.DRIVER_ADDRESS].value;
    }
    if (this.moduleName === AppSettings.ENTITY_CODE.PASS_PRIVILEGE_CONF) {
      this.selectedLocation = this.formName.controls[AppSettings.PASSENGER_PRIVILEGE_ATTRIBUTES.PASSENGER_PRIVILEGE_ADDRESS].value;
    }
    if (this.moduleName === AppSettings.ENTITY_CODE.PASSENGER) {
      this.selectedLocation = this.formName.controls[AppSettings.PASSENGER_ATTRIBUTES.PASSENGER_ADDRESS].value;
    }
    this.cancelBtnText = this.cs.getLabel("cancel");
    this.saveBtnText = this.cs.getLabel("label_save");
    this.defaultLbl = this.cs.getLabel("lbl_please_select");
    this.placeholder = this.cs.getLabelValue(`${this.moduleName  }.fields.${  this.field.attributeCode  }.placeholder`, this.attributeLabels, this.field.attributeCode);
  }

  getAndStoreAddress(event: any) {
    if (event.error) {
      this.errorMessage = event.error;
      this.formName.controls[AppSettings.LOCATION_ATTRIBUTES.LOCATION_GEOLOCATION]?.setErrors({require: false});
    } else {
      this.errorMessage = null;
      this.selectedLocation = event;
      this.markerlocation = { lat: this.selectedLocation.lat, lng: this.selectedLocation.lng };
      const latLong = `${this.selectedLocation.lat  }, ${  this.selectedLocation.lng}`;
      this.getReverseGeoCodeFromLatLng(latLong);
      const geoLocationValue = {
        address: this.selectedLocation.address,
        lat: this.selectedLocation.lat,
        lng: this.selectedLocation.lng
      };
      if (this.moduleName === AppSettings.ENTITY_CODE.LOCATION) {
        this.formName.controls[AppSettings.LOCATION_ATTRIBUTES.LOCATION_ADDRESS].setValue(geoLocationValue);
        this.formName.controls[AppSettings.LOCATION_ATTRIBUTES.LOCATION_GEOLOCATION].setValue(geoLocationValue.address);
      }
      if (this.moduleName === AppSettings.ENTITY_CODE.EVENTS) {
        this.formName.controls[AppSettings.EVENT_ATTRIBUTES.EVENT_ADDRESS].setValue(geoLocationValue);
        this.formName.controls[AppSettings.EVENT_ATTRIBUTES.EVENT_GEOLOCATION].setValue(geoLocationValue.address);
      }
      if (this.moduleName === AppSettings.ENTITY_CODE.DRIVER) {
        this.formName.controls[AppSettings.DRIVER_ATTRIBUTES.DRIVER_ADDRESS].setValue(geoLocationValue);
        this.formName.controls[AppSettings.DRIVER_ATTRIBUTES.DRIVER_GEOLOCATION].setValue(geoLocationValue.address);
      }
      if (this.moduleName === AppSettings.ENTITY_CODE.PASS_PRIVILEGE_CONF) {
        this.formName.controls[AppSettings.PASSENGER_PRIVILEGE_ATTRIBUTES.PASSENGER_PRIVILEGE_ADDRESS].setValue(geoLocationValue);
        this.formName.controls[AppSettings.PASSENGER_PRIVILEGE_ATTRIBUTES.PASSENGER_PRIVILEGE_GEOLOCATION].setValue(geoLocationValue.address);
      }
      if (this.moduleName === AppSettings.ENTITY_CODE.PASSENGER) {
        this.formName.controls[AppSettings.PASSENGER_ATTRIBUTES.PASSENGER_ADDRESS].setValue(geoLocationValue);
        this.formName.controls[AppSettings.PASSENGER_ATTRIBUTES.PASSENGER_GEOLOCATION].setValue(geoLocationValue.address);
      }
    }
   
  }


  showDialog() {
    this.visible = true;
    this.blockedDocument = true;
    this.showGoogleSearchBox = true;
    this.initMap();
  }

  close() {
    this.visible = false;
    this.blockedDocument = false;
    this.showGoogleSearchBox = false;
  }

  saveGeoLocation() {
    if (!this.newGeoLocation) {
      this.visible = false;
      this.blockedDocument = false;
      this.showGoogleSearchBox = false;
      return;
    }
    const latLngArray = this.newGeoLocation?.split(',');
    const geoLocationValue = {
      address: this.newGeoAddress,
      lat: latLngArray[0],
      lng: latLngArray[1]
    };
    this.selectedLocation = {
      address: this.newGeoAddress,
      lat: parseFloat(latLngArray[0]),
      lng: parseFloat(latLngArray[1])
    }
    if (this.moduleName === 'location') {
      this.formName.controls[AppSettings.LOCATION_ATTRIBUTES.LOCATION_ADDRESS].setValue(geoLocationValue);
      this.formName.controls[AppSettings.LOCATION_ATTRIBUTES.LOCATION_GEOLOCATION].setValue(this.newGeoAddress);
    }
    if (this.moduleName === 'event') {
      this.formName.controls[AppSettings.EVENT_ATTRIBUTES.EVENT_ADDRESS].setValue(geoLocationValue);
      this.formName.controls[AppSettings.EVENT_ATTRIBUTES.EVENT_GEOLOCATION].setValue(this.newGeoAddress);
    }
    if (this.moduleName === AppSettings.ENTITY_CODE.DRIVER) {
      this.formName.controls[AppSettings.DRIVER_ATTRIBUTES.DRIVER_ADDRESS].setValue(geoLocationValue);
      this.formName.controls[AppSettings.DRIVER_ATTRIBUTES.DRIVER_GEOLOCATION].setValue(this.newGeoAddress);
    }
    if (this.moduleName === AppSettings.ENTITY_CODE.PASS_PRIVILEGE_CONF) {
      this.formName.controls[AppSettings.PASSENGER_PRIVILEGE_ATTRIBUTES.PASSENGER_PRIVILEGE_ADDRESS].setValue(geoLocationValue);
      this.formName.controls[AppSettings.PASSENGER_PRIVILEGE_ATTRIBUTES.PASSENGER_PRIVILEGE_GEOLOCATION].setValue(this.newGeoAddress);
    }

    if (this.moduleName === AppSettings.ENTITY_CODE.PASSENGER) {
      this.formName.controls[AppSettings.PASSENGER_ATTRIBUTES.PASSENGER_ADDRESS].setValue(geoLocationValue);
      this.formName.controls[AppSettings.PASSENGER_ATTRIBUTES.PASSENGER_GEOLOCATION].setValue(this.newGeoAddress);
    }

    this.visible = false;
    this.blockedDocument = false;
    this.showGoogleSearchBox = false;
  }

  async initMap(): Promise<void> {
    let markerPoint;
    if (this.selectedLocation) {
      markerPoint = { lat: this.selectedLocation.lat, lng: this.selectedLocation.lng };
    } else {
      markerPoint = this.googleMapsService.getEventLocationCoordinates();
    }

    const { Map } = await google.maps.importLibrary('maps') as google.maps.MapsLibrary;
    const { AdvancedMarkerElement } = await google.maps.importLibrary('marker') as google.maps.MarkerLibrary;
    this.map = new Map(document.getElementById('map') as HTMLElement, {
      center: markerPoint,
      zoom: 15,
      mapTypeControl: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapId: this.googleMapsService.mapId
    });

    const marker = new AdvancedMarkerElement({
      map: this.map,
      position: markerPoint,
      gmpDraggable: true
    });

    this.position = this.selectedLocation ? markerPoint : this.googleMapsService.getEventLocationCoordinates();
    marker.position = this.position;
    const latLong = `${this.position.lat  }, ${  this.position.lng}`;
    this.getReverseGeoCodeFromLatLng(latLong);
    marker.addListener('dragend', () => {
      const currentPosition = marker.position as google.maps.LatLng;
      this.position = { lat: currentPosition.lat, lng: currentPosition.lng };
      const latLong = `${this.position.lat  }, ${  this.position.lng}`;
      this.getReverseGeoCodeFromLatLng(latLong);
    });
    this.map.panTo(this.position);
  }

  getReverseGeoCodeFromLatLng(latLong) {
    this.entityService.getReverseGeoCodeUsingLatLng(latLong).subscribe((result: any) => {
      if (result && result.results.length > 0) {
        this.newGeoAddress = null;
        this.newGeoAddress = result.results[0].formattedAddress;
        const { lat, lng } = result.results[0].geometry.location
        this.newGeoLocation = `${lat},${lng}`;
        this.placeId = result.results[0].placeId;
        this.formName.controls[AppSettings.LOCATION_ATTRIBUTES.LOCATION_PLACE_ID].setValue(this.placeId);
      }
    })
  }

}
